<template lang="pug">
div
  v-breadcrumbs.py-4(:items="breadcrumbItems")
    template(v-slot:item="{ item }")
      a.text-xs.no-underline.primary--text(v-if="!item.disabled" :href="item.href") {{ item.text }}
      .text-xs.primary400--text(v-else) {{ item.text }}
  v-divider.mb-2
  v-container.px-6
    div.heading-5.basic700--text {{ $t('send_message_to_customer') }}
    div.text-md.font-normal.basic700--text {{ $t('send_message_to_customer_desc') }}
    v-divider.my-6

    credit-alert(:credit="creditBalance" :title="$t('start_sending_message')" :showTitle="true" titleFont="heading-6" descFont="text-xs" buttonSize="button-sm")

    v-row(no-gutters)
      v-col(cols="12" sm="6")
        yc-text-field.mt-3(:label="$t('event_name')" v-model="eventName")
        yc-text-area.mt-3(:label="$t('message_template')" :placeholder="$t('send_message_placeholder')" v-model="message")
        div.text-xs.font-normal.basic600--text.mt-2 Character Count {{messageLength.length}} | SMS Count {{messageLength.numSMS}} | Cost RM {{messageLength.cost.toFixed(2)}}
        div.heading-6.basic700--text.mt-4 {{ $t('message_preview') }}
        v-card.message-preview-border.pa-4.mt-4.round-xl(outlined)
          div.text-md.font-normal(:class="message ? 'basic700--text' : 'basic500--text'") {{ message || $t('send_message_placeholder') }}

        v-btn.button-md.mt-8.mb-10(color="info500" :dark="!disabledSend" depressed :disabled="disabledSend" @click="openSendMessageDialog = true") {{ $t('send') }}

  .modals
    send-message-dialog(
      v-if="openSendMessageDialog"
      type="customers"
      :open.sync="openSendMessageDialog"
      :eventName="eventName"
      :message="message"
      :donors="selectedCustomers"
      @redirect="closeRedirect"
    )

</template>

<script>
import { mapGetters } from 'vuex'
import SendMessageDialog from '@/components/donation/dialogs/SendMessageDialog.vue'
import CreditAlert from '@/components/yezzabook/dialogs/CreditAlert.vue'

export default {
  components: { SendMessageDialog, CreditAlert },
  data () {
    return {
      currentTab: 0,
      breadcrumbItems: [
        {
          text: this.$t('customers'),
          disabled: false,
          href: '/admin/connect/customers'
        },
        {
          text: this.$t('send_message'),
          disabled: true
        }
      ],
      message: null,
      eventName: null,
      openSendMessageDialog: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      selectedCustomers: 'customers/getSelectedCustomers'
    }),
    messageLength() {
      const length = this.message ? this.message.length : 0;
      const numSMS = Math.ceil(length / 150);
      const cost = numSMS*0.1
      return { length, numSMS, cost };
    },
    creditBalance() {
      return this.company.prepaid_credits
    },
    disabledSend () {
      if (this.message && this.eventName) {
        return false
      }
      return true
    }
  },
  mounted () {
    if (!this.selectedCustomers.length) {
      this.$router.push('/admin/connect/customers')
    }
  },
  methods: {
    closeRedirect () {
      this.$router.push('/admin/connect/customers')
    }
  },
  destroyed () {
    // this.$store.commit('customers/resetSelectedCustomers')
  }
}
</script>

<style scoped>
.message-preview-border {
  border: var(--v-basic500) solid 1px;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>